
export const getAgencies = (token) => 
    fetch(`${process.env.REACT_APP_AGENCY_LOOKUP_API}/${token}`)
        .then(response => response.json())
        .then(data => data);

export const setAgenciesLog = (token, message) => 
    fetch(`${process.env.REACT_APP_AGENCY_LOOKUP_API}/${token}`, {
        method: "post",
        body: JSON.stringify({
            message
        }),
        headers: {
            "Content-Type": "application/json"
        }
    });

export const addLog = (message, packet = {}) =>
    fetch(`${process.env.REACT_APP_CHATBOT_API}/ewh-logging`, {
        method: "post",
        body: JSON.stringify({
            message,
            packet
        }),
        headers: {
            "Content-Type": "application/json"
        }
    });